var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            "tooltip-effect": "light",
            "header-cell-style": { background: "rgba(245, 245, 245, .3)" },
          },
        },
        [
          _vm._l(_vm.tableLabel, function (item, index) {
            return _c("el-table-column", {
              key: index,
              attrs: { "show-overflow-tooltip": "", label: item.name },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !item.slot
                          ? [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row[item.prop]) +
                                  "\n        "
                              ),
                            ]
                          : [
                              item.name == "任职状态"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.status
                                          ? _vm.$t("hr.onob")
                                          : _vm.$t("hr.dimission")
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "address", label: _vm.$t("public.operation") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handlePut(scope.row, scope.$index)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(scope.row, scope.$index)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("public.delete")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }